import { Dispatch } from "redux";

import { AssignedTasksStateAction } from "@reducers/types/taskManagement/assigned-tasks-state";

import {
  GET_TM_ASSIGNED_TASKS,
  GET_SINGLE_TM_ASSIGNED_TASKS,
  CREATE_TM_ASSIGNED_TASKS,
  UPDATE_TM_ASSIGNED_TASKS,
  DELETE_TM_ASSIGNED_TASKS,
} from "./types";

import { AssignedTasksCreateType } from "@type/taskManagement/assignedTasks";

import {
  fetchAssignedTasks,
  fetchAssignedTasksById,
  createAssignedTasks,
  updateAssignedTasks,
  deleteAssignedTasks,
} from "@api/taskManagement/assignedTasks";

export const assignedTasksFetchActionHandler =
  (query: any) => async (dispatch: Dispatch<AssignedTasksStateAction>) => {
    dispatch({ type: GET_TM_ASSIGNED_TASKS.LOADING, payload: true });

    try {
      const res = await fetchAssignedTasks(query);

      const { data, page, size, total } = res.data || {};

      dispatch({
        type: GET_TM_ASSIGNED_TASKS.SUCCESS,
        payload: {
          data,
          pagination: {
            page,
            size,
            total,
          },
        },
      });
    } catch (err) {
      dispatch({ type: GET_TM_ASSIGNED_TASKS.ERROR, payload: err });
    }
  };

export const assignedTasksByIdFetchActionHandler =
  (id: string | number) => async (dispatch: Dispatch<AssignedTasksStateAction>) => {
    dispatch({ type: GET_SINGLE_TM_ASSIGNED_TASKS.LOADING, payload: true });

    try {
      const res = await fetchAssignedTasksById(id);

      dispatch({
        type: GET_SINGLE_TM_ASSIGNED_TASKS.SUCCESS,
        payload: res.data || {},
      });
    } catch (err) {
      dispatch({ type: GET_SINGLE_TM_ASSIGNED_TASKS.ERROR, payload: err });
    }
  };

export const assignedTasksCreateActionHandler =
  (data: AssignedTasksCreateType) =>
  async (dispatch: Dispatch<AssignedTasksStateAction>) => {
    dispatch({ type: CREATE_TM_ASSIGNED_TASKS.LOADING, payload: true });

    try {
      const res = await createAssignedTasks(data);

      dispatch({ type: CREATE_TM_ASSIGNED_TASKS.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: CREATE_TM_ASSIGNED_TASKS.ERROR, payload: err });
    }
  };

export const assignedTasksUpdateActionHandler =
  (id: string | number, data: AssignedTasksCreateType) =>
  async (dispatch: Dispatch<AssignedTasksStateAction>) => {
    dispatch({ type: UPDATE_TM_ASSIGNED_TASKS.LOADING, payload: true });

    try {
      const res = await updateAssignedTasks(id, data);

      dispatch({
        type: UPDATE_TM_ASSIGNED_TASKS.SUCCESS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({ type: UPDATE_TM_ASSIGNED_TASKS.ERROR, payload: err });
    }
  };

export const assignedTasksDeleteActionHandler =
  (id: string | number) => async (dispatch: Dispatch<AssignedTasksStateAction>) => {
    dispatch({ type: DELETE_TM_ASSIGNED_TASKS.LOADING, payload: true });

    try {
      const res = await deleteAssignedTasks(id);

      dispatch({ type: DELETE_TM_ASSIGNED_TASKS.SUCCESS, payload: res.data });
    } catch (err) {
      dispatch({ type: DELETE_TM_ASSIGNED_TASKS.ERROR, payload: err });
    }
  };
